import { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// actions
import * as ziadostActions from "../../actions/ziadostActions";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import CheckboxComponent from "../../coraWebComponents/forms/Checkbox";
import * as convert from "../../coraWebComponents/utils/convert";
import { dateToDateStr } from "../../coraWebComponents/utils/convert";

import _ from "lodash";

const labelNames = {
  // INFO ZIADATEL
  meno: "Meno",
  priezvisko: "Priezvisko",
  nazov: "Názov",
  ico: "IČO",
  ULICA: "Ulica",
  CS: "ČS",
  CO: "ČO",
  PSC: "PSČ",
  OBEC: "Obec",
  email: "Email",
  telefon: "Telefón",

  // DOVOD/PRIORITA
  N_DOVOD: "Druh",
  N_PRIORITA: "Priorita",

  // DETAIL STAVBY
  N_TYP_PRACE: "Typ práce",
  NAZOV_PROJEKTU: "Názov projektu / Názov stavby",
  D_POZADOVANE_VYBAVENIEInSKFormat: "Dátum vybavenia",
  D_ZAC_STAVBYInSKFormat: "Očakávaný začiatok stavby",
  D_UKONC_STAVBYInSKFormat: "Očakávené ukočenie stavby",
  CIS_ZIAD_ISV: "Číslo žiadosti z IS výstavby",
  ID_STAV_ISV: "ID stavby z IS výstavby",
  STAVENISKO_NAZOV: "Názov spoločnosti",
  STAVENISKO_VEDUCI: "Vedúci stavby",
  STAVENISKO_KONTAKT: "Kontakt",

  // PRILOHY KOMENTARE
  KOMENTAR: "Komentár",
  filesNames: "Zoznam pripojených súborov",
};

const Rekapitulacia = (props) => {
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);

  const handleAgreementCheckChange = (name, newCheckedValue) => {
    setIsAgreementChecked(newCheckedValue);
  }

  // COMMON
  const renderData = (data) => {
    return Object.entries(data).filter(([key, value], i) => labelNames[key] && value).map(([key, value], i) => {
      const labelName = labelNames[key];

      if (Array.isArray(value) && value.length > 0) {
        return (
          <>
            <div key={i}>{`${labelName}:`}</div>
            <>
              {value.map((v, j) => (
                <div key={100 * i + j}>{v}</div>
              ))}
            </>
          </>
        );
      }

      return <div key={i}>{`${labelName}: ${value}`}</div>;
    });
  };

  const destructOsobneUdaje = (data) => {
    const { meno, priezvisko, nazov, ico, radioValue } = data;
    return {
      meno,
      priezvisko,
      nazov,
      ico,
      I_O_TYP: radioValue.value === "fyzOsoba" ? 1 : 2,
    };
  };
  const destructAdresa = (data) => {
    const { ulica, cs, co, psc, obec } = data;
    return { ulica, cs, co, psc, obec };
  };
  const destructAdresaStavby = (data) => {
    const { ULICA, CS, CO, PSC, OBEC } = data;
    return { ULICA, CS, CO, PSC, OBEC };
  };
  const destructKontakt = (data) => {
    const { telefon, email } = data;
    return { telefon, email };
  };

  // handle data
  const handleInfoZiadatelData = (data) => {
    const { Ziadatel, Vlastnik, L_VLASTNIK } = data;
    return {
      Ziadatel: {
        osobneUdaje: destructOsobneUdaje(Ziadatel),
        adresa: destructAdresa(Ziadatel),
        kontakt: destructKontakt(Ziadatel),
      },
      Vlastnik: {
        osobneUdaje: destructOsobneUdaje(Vlastnik),
        adresa: destructAdresa(Vlastnik),
        kontakt: destructKontakt(Vlastnik),
      },
      L_VLASTNIK,
    };
  };

  const handlDetailStavbyData = (data) => {
    const { DetailStavby } = data;
    const { I_TYP_PRACE } = DetailStavby;

    return {
      I_TYP_PRACE,
      NAZOV_PROJEKTU: DetailStavby.NAZOV_PROJEKTU,
      AdresaStavby: destructAdresaStavby(DetailStavby.AdresaStavby),
      D_POZADOVANE_VYBAVENIE: convert.addOffset(DetailStavby.D_POZADOVANE_VYBAVENIE),
      D_ZAC_STAVBY: convert.addOffset(DetailStavby.D_ZAC_STAVBY),
      D_UKONC_STAVBY: convert.addOffset(DetailStavby.D_UKONC_STAVBY),
      CIS_ZIAD_ISV: DetailStavby.CIS_ZIAD_ISV,
      ID_STAV_ISV: DetailStavby.ID_STAV_ISV,
      STAVENISKO_NAZOV: DetailStavby.STAVENISKO_NAZOV,
      STAVENISKO_VEDUCI: DetailStavby.STAVENISKO_VEDUCI,
      STAVENISKO_KONTAKT: DetailStavby.STAVENISKO_KONTAKT,
    };
  };

  const handlOblastZaujmuData = (data) => {
    const { coords } = data;
    return { coords };
  };

  const handlPrilohyKomentarData = (KOMENTAR) => {
    return { KOMENTAR };
  };

  const base64ToFile = (base64, fileName) => {
    return convert.base64ToFile(base64, fileName);
  }

  const handleOnClick = async (e) => {
    const { podatZiadost, ziadost, cancel } = props;
    const { InfoZiadatel, Dovod, Priorita, PrilohyKomentar, OblastZaujmu } = ziadost;

    const { filesNames, prilohy, KOMENTAR } = PrilohyKomentar;
    const data = {
      InfoZiadatel: handleInfoZiadatelData(InfoZiadatel),
      Dovod: Dovod,
      Priorita: Priorita,
      DetailStavby: handlDetailStavbyData(ziadost),
      OblastZaujmu: handlOblastZaujmuData(OblastZaujmu),
      PrilohyKomentar: handlPrilohyKomentarData(KOMENTAR),
    };

    const mapaImage = base64ToFile(OblastZaujmu.image, "mapa");
    await podatZiadost(data, mapaImage, filesNames, prilohy);
    cancel();
  };


  const { className, cancel, moveBack, isLoading, ziadost, image } = props;
  const { InfoZiadatel, Dovod, Priorita, DetailStavby, PrilohyKomentar } = ziadost;
  const stavenisko = {
    STAVENISKO_NAZOV: DetailStavby ? DetailStavby.STAVENISKO_NAZOV : "",
    STAVENISKO_VEDUCI: DetailStavby ? DetailStavby.STAVENISKO_VEDUCI : "",
    STAVENISKO_KONTAKT: DetailStavby ? DetailStavby.STAVENISKO_KONTAKT : "",
  };
  const doleziteData = {
    D_POZADOVANE_VYBAVENIEInSKFormat: DetailStavby ? dateToDateStr(DetailStavby.D_POZADOVANE_VYBAVENIE) : null,
    D_ZAC_STAVBYInSKFormat: DetailStavby ? dateToDateStr(DetailStavby.D_ZAC_STAVBY) : null,
    D_UKONC_STAVBYInSKFormat: DetailStavby ? dateToDateStr(DetailStavby.D_UKONC_STAVBY) : null,
    CIS_ZIAD_ISV: DetailStavby ? DetailStavby.CIS_ZIAD_ISV : null,
    ID_STAV_ISV: DetailStavby ? DetailStavby.ID_STAV_ISV : null,
  };
  const media = window.matchMedia('only screen and (min-width: 768px)');

  return (
    <div className={`row m-0 ${className}`}>
      <div className={media.matches ? "col-8 offset-2 p-0 forWeb" : "col p-0 forMobile"}>
        <div className="card formular">
          <div className="form-body">
            <div className="card-title">
              <div>Rekapitulácia</div>
            </div>

            {/* INFORMACIA O ZIADATELOVI */}
            {InfoZiadatel?.Ziadatel && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Žiadateľ:</div>
                {renderData(InfoZiadatel.Ziadatel)}
              </>
            )}
            {InfoZiadatel?.Vlastnik && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Vlastník:</div>
                {renderData(InfoZiadatel.Vlastnik)}
              </>
            )}

            {/* DOVOD/PRIORITA */}
            {Dovod && Priorita && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Druh žiadosti:</div>
                {renderData(Dovod)}
                {renderData(Priorita)}
              </>
            )}

            {/* DETAIL STAVBY */}
            {DetailStavby && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Detail stavby:</div>
                {renderData({ N_TYP_PRACE: DetailStavby.N_TYP_PRACE, NAZOV_PROJEKTU: DetailStavby.NAZOV_PROJEKTU })}
              </>
            )}
            {DetailStavby?.AdresaStavby && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Adresa stavby:</div>
                {renderData(DetailStavby.AdresaStavby)}
              </>
            )}
            {!(_.isNil(doleziteData.D_POZADOVANE_VYBAVENIEInSKFormat) && _.isNil(doleziteData.D_ZAC_STAVBYInSKForma) && _.isNil(doleziteData.D_UKONC_STAVBYInSKForma) && _.isNil(doleziteData.CIS_ZIAD_ISV) && _.isNil(doleziteData.ID_STAV_ISV)) && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Dôležité dáta:</div>
                {
                  renderData(doleziteData)
                }
              </>
            )}
            {DetailStavby && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Stavenisko:</div>
                {renderData(stavenisko)}
              </>
            )}

            {/* OBLAST ZAUJMU */}
            {image && (
              <>
                <p>&nbsp;</p>
                <div className="recapSubtitle">Oblasť záujmu:</div>
                <img
                  style={{ width: "200px" }}
                  src={`${image}`}
                  alt="ThumnailPhoto"
                ></img>
              </>
            )}

            {/* KOMENTAR A PRILOHY */}
            {PrilohyKomentar &&
              (PrilohyKomentar.KOMENTAR !== "" ||
                PrilohyKomentar.filesNames.length !== 0) && (
                <>
                  <p>&nbsp;</p>
                  <div className="recapSubtitle">Prílohy a komentáre:</div>
                  {renderData(PrilohyKomentar)}
                </>
              )}
            {/* POTVRDENIE */}
            <div className="mt-4 pb-2 border">
              <div className="py-2 px-3">
                V prípade, že spoločnosť SITEL, s.r.o. je dotknutou osobou, a ak na základe žiadateľa nebude možné vydať úplné záväzné vyjadrenie, budete na ich doplnenie vyzvaný.<br />
                <span className="text-danger">Počas doby do doplnenia údajov lehota na vyjadrenie neplynie!</span>
                <CheckboxComponent label="Uvedené beriem na vedomie." value={isAgreementChecked} onChange={handleAgreementCheckChange} />
              </div>
            </div>
            {/* BUTTONS */}
            <div className="k-form-field flexGroup">
              <Button primary label="Zrusiť" onClick={cancel} />
              <div className="flexGroup">
                <Button primary label="Späť" onClick={moveBack} />
                <Button
                  label="Podať žiadosť"
                  disabled={!isAgreementChecked}
                  onClick={handleOnClick}
                  primary
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoadingPanel isLoading={isLoading} />
    </div>
  );

}


const mapStateToProps = (state) => ({
  isLoading: state.ziadost.isLoading,
  coords: state.mapa.coords,
  image: state.mapa.image,
});

const mapDispatchToProps = (dispatch) => ({
  podatZiadost: async (ziadost, mapaImage, fileNames, files) =>
    dispatch(ziadostActions.podatZiadost(ziadost, mapaImage, fileNames, files)),
});

Rekapitulacia.propTypes = {
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  podatZiadost: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  ziadost: PropTypes.object,
  coords: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Rekapitulacia)
);
